import { PurchaseEntryResponseData } from "@lib/titan2-slingo/dist/api/data/PurchaseEntryResponseData";
/**
 * ExtendedPurchaseEntryResponseData.ts
 */
export class ExtendedPurchaseEntryResponseData extends PurchaseEntryResponseData {
}
//# sourceMappingURL=ExtendedPurchaseEntryResponseData.js.map